import React, { useEffect } from "react";
import "./ImageLightbox.scss";

// Полноэкранный просмотр картинки без обрезки - для миниатюр ответов теста
// (single/ordering/matching), которые в списке/результатах всегда квадратные,
// а тут показывают файл как есть, в исходных пропорциях. Закрытие по клику на
// фон/крестик или Escape.
const ImageLightbox = ({ src, onClose }) => {
    useEffect(() => {
        if (!src) return;
        const onKeyDown = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [src, onClose]);

    if (!src) return null;

    return (
        <div className="image_lightbox_overlay" onClick={onClose}>
            <div className="image_lightbox_close" onClick={onClose}>×</div>
            <img
                className="image_lightbox_img"
                src={src}
                alt=""
                onClick={(e) => e.stopPropagation()}
            />
        </div>
    );
};

export default ImageLightbox;
